export const untitleduiIcons = {
  check: require('./untitledui/check.svg'),
  'download-02': require('./untitledui/download-02.svg'),
  'edit-05': require('./untitledui/edit-05.svg'),
  'edit-02': require('./untitledui/edit-02.svg'),
  'at-sign': require('./untitledui/at-sign.svg'),
  'message-chat-circle': require('./untitledui/message-chat-circle.svg'),
  'message-chat-circle-fill': require('./untitledui/message-chat-circle-fill.svg'),
  'plus': require('./untitledui/plus.svg'),
  'arrow-up': require('./untitledui/arrow-up.svg'),
  'attachment-01': require('./untitledui/attachment-01.svg'),
  'image-01': require('./untitledui/image-01.svg'),
  'camera-01': require('./untitledui/camera-01.svg'),
  'camera-02': require('./untitledui/camera-02.svg'),
  'file-06': require('./untitledui/file-06.svg'),
  'phone-plus': require('./untitledui/phone-plus.svg'),
  'phone': require('./untitledui/phone.svg'),
  'phone-fill': require('./untitledui/phone-fill.svg'),
  'users-01': require('./untitledui/users-01.svg'),
  'user-plus-01': require('./untitledui/user-plus-01.svg'),
  'users-02': require('./untitledui/users-02.svg'),
  'shield-tick': require('./untitledui/shield-tick.svg'),
  'corner-down-left': require('./untitledui/corner-down-left.svg'),
  'corner-up-left': require('./untitledui/corner-up-left.svg'),
  'edit-01': require('./untitledui/edit-01.svg'),
  'info-circle': require('./untitledui/info-circle.svg'),
  'arrow-right': require('./untitledui/arrow-right.svg'),
  'arrow-left': require('./untitledui/arrow-left.svg'),
  'chevron-right': require('./untitledui/chevron-right.svg'),
  'loading-02': require('./untitledui/loading-02.svg'),
  'user-up-02': require('./untitledui/user-up-02.svg'),
  'user-down-02': require('./untitledui/user-down-02.svg'),
  'menu-01': require('./untitledui/menu-01.svg'),
  'settings': require('./untitledui/settings-01.svg'),
  'settings-fill': require('./untitledui/settings-01-fill.svg'),
  'clock': require('./untitledui/clock.svg'),
  'phone-call-01': require('./untitledui/phone-call-01.svg'),
  'phone-incoming-01': require('./untitledui/phone-incoming-01.svg'),
  'phone-x': require('./untitledui/phone-x.svg'),
  'phone-hang-up': require('./untitledui/phone-hang-up.svg'),
  'copy': require('./untitledui/copy-01.svg'),
  'dots-horizontal': require('./untitledui/dots-horizontal.svg'),
  'copy-05': require('./untitledui/copy-05.svg'),
  'pin-01': require('./untitledui/pin-01.svg'),
  'pencil-line': require('./untitledui/pencil-line.svg'),
  'clock-stopwatch': require('./untitledui/clock-stopwatch.svg'),
  'trash-03': require('./untitledui/trash-03.svg'),
  'share-06': require('./untitledui/share-06.svg'),
  'message-text-circle-02': require('./untitledui/message-text-circle-02.svg'),
  'message-x-circle': require('./untitledui/message-x-circle.svg'),
  'pin-02': require('./untitledui/pin-02.svg'),
  'pin-02-filled': require('./untitledui/pin-02-filled.svg'),
  'pin-blocked-02': require('./untitledui/pin-blocked-02.svg'),
  'video-recorder': require('./untitledui/video-recorder.svg'),
  'check-circle': require('./untitledui/check-circle.svg'),
  'sticker-circle': require('./untitledui/sticker-circle.svg'),
  'slash-line': require('./untitledui/slash-circle-01.svg'),
  'slash-circle-01': require('./untitledui/slash-circle-01.svg'),
  'message-notification-circle': require('./untitledui/message-notification-circle.svg'),
  'home-line-fill': require('./untitledui/home-line-fill.svg'),
  'home-line': require('./untitledui/home-line.svg'),
  'link-external-02': require('./untitledui/link-external-02.svg'),
  'calendar': require('./untitledui/calendar.svg'),
  'bell-off-01': require('./untitledui/bell-off-01.svg'),
  'bell-01': require('./untitledui/bell-01.svg'),
  'bell-off': require('./untitledui/bell-off.svg'),
  'menu-03': require('./untitledui/menu-03.svg'),
  'menu-05': require('./untitledui/menu-05.svg'),
  'microphone-01': require('./untitledui/microphone-01.svg'),
  'stop-circle': require('./untitledui/stop-circle.svg'),
  'play-circle': require('./untitledui/play-circle.svg'),
  'pause-circle': require('./untitledui/pause-circle.svg'),
  'lock-03': require('./untitledui/lock-03.svg'),
  'microphone-filled': require('./untitledui/microphone-filled.svg'),
  'x-circle': require('./untitledui/x-circle.svg'),
  'log': require('./untitledui/file-05.svg'),
  'message-circle-02': require('./untitledui/message-circle-02.svg'),
}
